const numberCountData = [
  {
    _id: 1,
    count: 97672,
    title: "Subcribed Clients"
  },
  {
    _id: 2,
    count: 15763,
    title: "Predictions"
  },
  {
    _id: 3,
    count: 52987,
    title: "Happy Client"
  }
];

export default numberCountData;